import { useEffect, useState } from "react";
import korrectLogo from '../../assets/images/korrectLogoIcon.png';
import templateServices from "./templateServices";
import { CommonUtilities } from "commonUtils";
import { forEachChild } from "typescript";
import TemplateDrawer from "./TemplateDrawer";

export default function TemplateList(param: any) {

    let [TemplateListing, setTemplateListing] = useState<any>([]);
    let [ViewName, setViewName] = useState<any>([]);
    useEffect(() => {

        var payload = {
            type: "existingTemplate"
        }

        let distinct: string[] = [];
        if (param.activeMenu === "existingTemplate") {

            templateServices.genericAPIListing(payload).then((value: any) => {
                var obj = (CommonUtilities.relativeDataRemapping(value.data, value.headers.original));
                TemplateListing = obj
                setTemplateListing(TemplateListing)
                console.log(TemplateListing)
                ViewName = []
                for (const list of TemplateListing) {

                    if (list.viewName && !distinct.includes(list.viewName.toLowerCase())) {
                        distinct.push(list.viewName.toLowerCase())
                    }
                }
                ViewName = distinct;
                setViewName(ViewName)

            })

            console.log(distinct)
        }
    }, [param]);

    let [search, setSearch] = useState("");
    let [pageSize, setPageSize] = useState(5);
    let [openDrawer, setOpenDrawer] = useState(false);
    let [EditTemplate, setEditTemplate] = useState<any>([]);

    const ExportTemplate = (e: any) => {

        const filename = e?.templateName + '.csv';
        const keys = e?.templateHeader.split(",").map((k: any) => k.trim());
        const templateObject = Object.fromEntries(keys.map((key: any) => [key, ""]));

        console.log(templateObject)

        const data = [templateObject];
        CommonUtilities.exportToCSV(data, filename.toString());
    }

    const windowExport = (e: any) => {
        var url = 'metaData/genericV1/getAllTemplate/' + e;
        window.open(url);
    }

    const closeTemplateDrawer = (e: any) => {
        openDrawer = false;
        setOpenDrawer(openDrawer)
    }


    return (
        <>
            <div className="pm ws-12 ">

                <div className="pm ms ws-12 box mbl">

                    <h1 className="mb pm"> {ViewName.length} Records</h1>
                    <input type="text" placeholder="Search" className="mll ws-10" value={search} onChange={(e) => { setSearch(e.target.value) }} />

                    <select className="ws-1 pull-right" onChange={(e) => setPageSize(Number(e.target.value))}>
                        {[5, 10, 20, 50, 100].map((value) => (
                            <option key={value} value={value}>
                                {value}
                            </option>
                        ))}
                    </select>
                </div>

                <div className="pm ms ws-12 box mb">
                    <h2 className="ws-3"> Template Name </h2>
                    <h2 className="ws-2"> Kontact Code </h2>
                    <h2 className="ws-2"> Template Id</h2>
                    <h2 className="ws-3"> Display Name</h2>
                </div>

                {ViewName?.slice(0, pageSize).filter((VName: any) => search.length === 0 || VName.toLowerCase().includes(search.toLowerCase())).map((values: any) => {
                    return (
                        <div className="box pm mb">
                            <div className="ws-12">
                                <span className="text-bold ws-10 mt ml">{values} </span>
                                <button className="btn-s btn-info btn pull-right" onClick={() => windowExport(values)} ><i className="icon-download1"></i></button>
                            </div>
                            <hr />
                            <div className="ws-12 ptl box">

                                {TemplateListing?.filter((listing: any) =>
                                    listing?.viewName?.toLowerCase() === values?.toLowerCase()
                                ).map((listing: any) => (
                                    <div key={listing.viewName} className="pm ms ws-12">
                                        <span className="ws-3"> {listing.templateName} </span>
                                        <span className="ws-2"> {listing.kontactCode} </span>
                                        <span className="ws-2"> {listing.templateId} </span>
                                        <span className="ws-3"> {listing.displayName} </span>
                                        <div className="ws-2 pull-right forceSingleLine">
                                            <button className="btn-sm btn-info btn pull-right" onClick={() => { setEditTemplate(listing); setOpenDrawer(true) }}><i className="icon-edit"></i></button>
                                            <button className="btn-sm btn-info btn pull-right" onClick={() => { ExportTemplate(listing); }}><i className="icon-download1"></i></button>

                                            <div className="verticalMediumWide hover-box text-center">

                                                <ul className="hover-block textboxDropdownList box overflowVisible contentWidth">

                                                    <li className="hover-box width-auto pm">
                                                        <span className="text-bold">{listing.templateHeader}</span>
                                                    </li>

                                                </ul>

                                                <button type="button" className="btn-sm btn-info btn pull-right">
                                                    <i className="icon-info1"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                ))
                                }
                            </div>
                        </div>
                    )
                })}

                <div>
                    {(() => {

                        if (openDrawer) {
                            return (<TemplateDrawer EditTemplate={EditTemplate} openDrawer={openDrawer} closeTemplateDrawer={closeTemplateDrawer} />)
                        }
                        
                    })()}
                </div>
            </div>
        </>
    )
}